module.exports = __webpack_public_path__ + "img/itoc_adixnt_header.86f09f3f.png";